import * as React from 'react';

import { observer } from 'mobx-react';
import { MainFooter } from 'telia-front-react/main';
import { AppFooter } from '@teliaee/telia-megamenu';
import { useStores } from "@stores/RootStore";

const FooterContainer = () => {
  const { menuStore } = useStores();

  return (
    <MainFooter>
      <AppFooter {...menuStore.getFooterProps()}/>
    </MainFooter>
  );
}

export default observer(FooterContainer);
